<template >
  
  <v-app>
  
    <v-main dense dark :style=img_bg_style>
      <!-- Apply for Small to medium tablet and Small to large phone -->
      <v-container dense class="hidden-md-and-up" align="center" justify="center" bg fill-height grid-list-md text-xs-center > 
        <v-layout dense row wrap align-center>
          <v-flex dense>
            <div class="d-flex align-center flex-column ">
              <span style="color: white; font-weight: normal; font-size: xx-large ">HVS Smart</span>
            </div> 
            <v-card-text>            
              <v-text-field 
                ref="userId"
                v-model="userData.userId"
                name="login"
                class="mt-5"
                autocomplete="off"
                placeholder="User ID"
                type="text"
                outlined
                @keyup.enter="signIn()"           
                label="User ID" 
                prepend-inner-icon="mdi-account-circle" 
                dark
                color="green"
                rounded
              />
              <v-text-field 
                label="Password" 
                :type="showPassword ? 'text' : 'password'"
                prepend-inner-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                v-model="userData.userPw"
                name="password"
                class="mt-5"
                autocomplete="off"
                placeholder="Password"
                outlined
                @keyup.enter="signIn()"
                dark
                color="green"
                rounded
              />
            </v-card-text>

            <div class="d-flex justify-end mr-5 ml-4">
              <v-icon dark small class="mt-0">mdi-key-change</v-icon>
              <span 
                class="white--text body-2 ml-2 mt-2"
                @click="getChgPW"
                >Change Password</span>
              <v-spacer></v-spacer>
              <v-checkbox 
                  dense
                  dark
                  color="success"
                  v-model="isSaveID" 
                  label="Remember me" 
                  on-icon="mdi-check-circle-outline" 
                  off-icon="mdi-checkbox-blank-circle-outline" 
              />
            </div> 

            <div>  
              <v-card-actions class="d-flex align-center flex-column mx-2 mt-3">
                <v-btn 
                  dark
                  block 
                  x-large 
                  elevation="0" 
                  outlined
                  class="btn__login" 
                  @click="signIn()">{{ $t('login') }}
                </v-btn>
              </v-card-actions> 
            </div>  
          </v-flex>
        </v-layout>
        <!-- ===================================== -->
        <v-snackbar v-model="snackbar" :timeout="timeout" color="error" top>
            {{ msg }}
          </v-snackbar>

        <LoginFail :showFail.sync="showFail" />

      </v-container>

      <!-- Apply for Large tablet to laptop -->
      <v-container class="hidden-sm-and-down" align="center" justify="center" bg fill-height grid-list-md text-xs-center > 
        <v-layout dense row wrap align-center>
          <v-flex dense>
            <v-card class="mx-auto pa-3" max-width="450" >    
              <v-form>
                <v-card-title class="d-flex align-center flex-column" text rounded >
                  <div class="text-h4 mb-2 mt-5">
                    <span style="color: red ; font-weight: bold; ">LOGIN</span>
                  </div>
                        
                </v-card-title>
              </v-form>        
              
              <v-card-text>
              
                <v-text-field 
                  v-model="userData.userId"
                  name="login"
                  class="user-info"
                  autocomplete="off"
                  placeholder="User ID"
                  type="text"
                  outlined
                  @keyup.enter="signIn()"           
                  label="User ID" 
                  prepend-icon="mdi-account-circle" 
                />
                <v-text-field 
                  label="Password" 
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  v-model="userData.userPw"
                  name="password"
                  class="user-info mt-6"
                  autocomplete="off"
                  placeholder="Password"
                  outlined
                  @keyup.enter="signIn()"
                />
              </v-card-text>

              <div class="d-flex justify-end mr-5 ml-4">
                <v-icon large class="mt-0">mdi-key-change</v-icon>
                <span 
                  class="black--text body-2 ml-2 mt-2"
                  @click="getChgPW"
                  >Change Password</span>

                <!-- <span 
                  class="black--text subtitle-2 font-weight-bold ml-4 mt-1"
                  @click="getChgPW"
                  >Change Password</span> -->
                <v-spacer></v-spacer>
                <v-checkbox 
                    color="success"
                    v-model="isSaveID" 
                    label="Remember me" 
                    on-icon="mdi-check-circle-outline" 
                    off-icon="mdi-checkbox-blank-circle-outline" 
                />
              </div> 

              <v-card-actions class="d-flex align-center flex-column ml-2 mr-2">
                <v-btn block x-large elevation="0" class="btn__login" 
                  @click="signIn()">{{ $t('login') }}
                </v-btn>
              </v-card-actions> 
            </v-card>

          </v-flex>
        </v-layout>
        <v-snackbar v-model="snackbar" :timeout="timeout" color="error" top>
            {{ msg }}
          </v-snackbar>

        <LoginFail :showFail.sync="showFail" />

      </v-container>

      <!-- Show Dialog Change Password -->
      <v-dialog 
          v-model="dialogChgPW" 
          width="800px"                  
          scrollable
          persistent
        >
          <v-card >
            <v-card-title class="d-flex cyan darken-1 mx-n5">
              <v-icon dark>mdi-key-change</v-icon>
              <span class="subtitle-1 yellow--text ml-2">                
                Change Password
              </span>
              <v-spacer></v-spacer>
              <v-btn                   
                icon
                @click="dialogChgPW=!dialogChgPW"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text >
              <!-- <DxScrollView
                height="100%"
                width="100%"> -->
                <v-card  class="mx-auto" dense > 
                  <template >
                    <v-layout column class="mt-5">
                      <v-row dense class="form-layout">
                        <v-col cols="5" class="pr-2 pt-1 ">
                          <span>Current Password</span>
                        </v-col>
                        <v-col cols="7" class="pl-2 pt-1 form-border-right">
                          <v-text-field
                              v-model="currentPassword"
                              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="show1 ? 'text' : 'password'"
                              dense
                              @click:append="show1 = !show1"
                          />
                        </v-col>
                      </v-row>
                      <v-row dense class="form-layout mt-0">
                        <v-col cols="5" class="pr-2 pt-1 ">
                          <span>New Password</span>
                        </v-col>
                        <v-col cols="7" class="pl-2 pt-1 form-border-right">
                          <v-text-field
                              v-model="newPassword"
                              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="show2 ? 'text' : 'password'"
                              dense
                              @click:append="show2 = !show2"
                          />
                        </v-col>
                      </v-row>
                      <v-row dense class="form-layout mt-0">
                        <v-col cols="5" class="pr-2 pt-1 form-border-bottom-left  ">
                          <span class="red--text">Confirm Password</span>
                        </v-col>
                        <v-col cols="7" class="pl-2 pt-1  form-border-bottom form-border-right">
                          <v-text-field
                              v-model="confirmPassword"
                              :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="show3 ? 'text' : 'password'"
                              dense
                              @click:append="show3 = !show3"
                          />
                        </v-col>
                      </v-row>
                      <v-divider class="mt-5"></v-divider>
                      <v-row dense class="ma-2">
                        <v-spacer></v-spacer>
                       <v-chip
                        label
                        link
                        @click="btnSave"
                        class="red--text"
                       >
                        Change Password
                       </v-chip>
                      </v-row>

                      <div dense class="mt-2">
                        <li>Password should be Character and Number.</li>
                        <li>Password must be over 6 character and less than 12 character.</li>
                      </div>

                    </v-layout>
                  </template>
                </v-card> 
                  
              <!-- </DxScrollView>    -->
            </v-card-text>
              
          </v-card>
          
        </v-dialog>

    </v-main>

    <v-footer
      app        
      padless
      dark
    >
      <v-flex dark>
          <div class="d-flex align-md-center justify-center pa-1">
          <v-img :src="require(`@/assets/images/bg/hvs-footer.png`)" contain max-height="18" max-width="20" > </v-img>
            <span  style="color: white; font-size: 13px ">                
              <strong> HD HYUNDAI VIETNAM SHIPBUILDING</strong>
            </span>
          </div>      
      </v-flex> 
    </v-footer>
  </v-app>
</template>
  
<script>
import baseview from '@/components/base/baseview'
import { fn_Login, } from '@/framework/login/login'
import { updatePassword, } from '@/api/view/pp/common/common.js'
import Cookies from 'js-cookie'
import LoginFail from '@/layout/login/LoginFail'
import router from '@/router'
import { DxScrollView } from "devextreme-vue/scroll-view"
import notify from 'devextreme/ui/notify' // message

export default {
  name: 'login',
  mixins: [baseview],
  components: {
    LoginFail,
  },
  data() {
    return {
      showPassword:false,
      showFail: false,
      userData: {
        userId: '',
        userPw: '',
        sysId: '',
        // system: 'SMART',
      },
      isSaveID: false,
      image: require(`@/assets/images/bg/bg_login.jpg`),

      snackbar: false,
      msg: '',
      timeout: 2000,
      // Dialog Change Password
      dialogChgPW: false,
      currentPassword : '',
      newPassword : '',
      confirmPassword : '',
      show1 : false,
      show2 : false,
      show3 : false,
      userGrd: this.$store.state.user.userGrd,


    }
  },
  mounted() {
    this.$nextTick(() => this.$refs.userId.$refs.input.focus());    
  }, 
  computed: {
    img_bg_style: function(){
        var bgImg= this.image

      return {
                "height": "100",
                "background-image": 'url(' + bgImg + ')', 
                "background-repeat": "no-repeat", 
                "background-size": "cover",
                "background-position": "center",
                "opacity": "1"
      }
    },
  },
  created() {
    // Multilingual store registration
    this.setLocale()

    // this.$store.dispatch('user/ClearSession')
    this.$store.dispatch('system/ClearSession')

    const savedId = Cookies.get('pp_saveid')

    const savedPw = Cookies.get('pp_savepw')    
    const saveRem = Cookies.get('pp_rem')  
    
    
     
    // if(savedId) {
    if(saveRem){  
      this.isSaveID = true
      this.userData.userId = savedId
      this.userData.userPw = savedPw
      
      this.signIn()  
    } else {
      this.isSaveID = false
    }
  },
  methods: {
    // log in
    signIn() {
      if(this.isSaveID) {
        let expDt = new Date()
        expDt.setTime(expDt.getTime() + 1000 * 3600 * 24 * 30); // 30 days
        Cookies.set('pp_saveid', this.userData.userId, { expires: expDt, path: '' })
        Cookies.set('pp_savepw', this.userData.userPw, { expires: expDt, path: '' })
        Cookies.set('pp_rem', true, { expires: expDt, path: '' })

      } else {
        Cookies.remove('pp_saveid')
        Cookies.remove('pp_savepw')
        Cookies.remove('pp_rem')

      }

      fn_Login(this.userData).then((res) => {
          if (res.result) {            
            router.push('/mainLayout') 
            // this.$router.push({ name: 'v20Menu' }) ;  // 👉 Điều hướng ngay tại đây
          } else {
            if(res.msg !== 'loginFail') {
              this.snackbar = true
              this.msg = res.msg
            } else {
              this.showFail = true
            }
          }
        })

    },
    // multilingual setting
    setLocale() {
      if (!this.$localStore.get('locale')) {
        this.$localStore.set('locale', this.$vuetify.lang.current)
      } else {
        // if (this.$localStore.get('locale') == 'ko') {
        //   this.$vuetify.lang.current = 'ko'
        //   this.$i18n.locale = 'ko'
        // } else {
          this.$vuetify.lang.current = 'en'
          this.$i18n.locale = 'en'
        // }
      }
    },

    // Change Password
    initChgPW() {
            this.currentPassword = '',
            this.newPassword = '',
            this.confirmPassword = ''
        },
    getChgPW(){
      // console.log("Show Dialog ", this.userData.userId);
      if(this.userData.userId == '' || this.userData.userId == null){
        this.snackbar = true
        this.msg = 'Input UserID to change password.'
        // notify(this.$t('Input User ID.'), 'error', 3000);
        return;
      }
      this.initChgPW()
      this.dialogChgPW = true
    },

    async btnSave() {

      if(this.currentPassword === null || this.currentPassword === ''){
        notify(this.$t('Input current password.'), 'error', 3000);
        return;
      }

      if(this.newPassword === null || this.newPassword === ''){
        notify(this.$t('Input new password.'), 'error', 3000);
        return;
      }

      if(this.confirmPassword === null || this.confirmPassword === ''){
        notify(this.$t('Input confirm password.'), 'error', 3000);
        return;
      }

      if(this.newPassword != this.confirmPassword){
        notify(this.$t('New password is different with confirm password.'), 'error', 3000);
        return;
      }

      if (this.userGrd != "A" && this.newPassword == this.currentPassword) {
        notify(this.$t('New password must be different with old password.'), 'error', 3000);
        return;
      }

      if (this.newPassword < 6) {
        notify(this.$t('Password must be over 6 character.'), 'error', 3000);
        return;
      }


      let firstChar = this.newPassword.substring(0, 1);
      if (!((firstChar >= "A" && firstChar <= "Z") || (firstChar >= "a" && firstChar <= "z"))){
        notify(this.$t('Password must be start with alphabet.'), 'error', 3000);
        return;
      }

      let includeNumber = false;
      let includeSpace  = false;
      for ( var i = 0; i < this.newPassword.length; i++){
        let myChar = this.newPassword.substring(i, i + 1);
        if (myChar >= "0" && myChar <= "9") { includeNumber = true; }
        if (myChar == " ") { includeSpace = true; }
      }

      if (!includeNumber) {
        notify(this.$t('Password must be contain number.'), 'error', 3000);
        return;
      }
      if (includeSpace) {
        notify(this.$t('Password cannot contain space.'), 'error', 3000);
        return;
      }

      let params = {
        userId: this.userData.userId,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      }
      // console.log("save password button click", params);

      this.openLoading('Change password...')
      updatePassword(params)
          .then(res => {
            notify(this.$t("Your password is successfully changed."), 'success', 3000)
            //notify(this.$t('changed'), 'success', 1500)
            this.dialogChgPW = false
          })
          .catch(error => {
            notify(this.$t('An error has occurred while changing password.<br>nCheck your old password and try again.'), 'error', 3000)
            //notify(error, 'error', 1500)
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
           
          })
    },


  },
}
</script>

<style scoped>
  
  .v-application .rounded-bl-xl {
      border-bottom-left-radius: 300px !important;
  }
  .v-application .rounded-br-xl {
      border-bottom-right-radius: 300px !important;
  }

  .container.grid-list-md .layout:not(:only-child) {
    margin: auto;
  }

  .text-green input {
      color: green !important;
  }

  .cardColor {
    background-color: white!important;
    border-color: transparent!important;
    opacity: 0;
  }
  .btn__login {
      border-radius: 5px;
      background: linear-gradient(90deg, #8bf35b 0%, #039233 100%);
      color: #ffffff !important;
      font-weight: bold;
      font-size: 18px !important;
  }

  .btn__link {
      border-radius: 0px;
      background: linear-gradient(90deg, #6ed43f 0%, #039233 100%);
      color: #ffffff !important;
      font-weight: bold;
      font-size: 14px !important;
  }  
  .user-info {
      border-radius: 5px;
      font-weight: bold;
      font-size: 14px !important;
      color: #ffffff !important;
  } 

  .v-text-field fieldset, .v-text-field .v-input__control {
    color: #6cf336;
  }
  .v-input {
    font-size: 18px;
    border-radius: 5px;
    font-weight: 700;
  }
  .v-input .v-label {
    font-size: 18px;
    font-weight: 700;
  }

  .v-input__slot {
    align-items: center;
    color: lightgreen;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
  }

  .v-application .success--text {
      color: #00ff1e !important;
      caret-color: #ffffff !important;
  }

  .v-icon.v-icon {
    font-size: 40px;
  }

  .v-text-field--rounded > .v-input__control > .v-input__slot {
    padding: 0 8px;
  }  

  </style>